import React, { FC } from 'react';
import styles from './AboutSection.module.scss';
import classNames from 'classnames';

const AboutSection: FC = () => {
    return (
        <div className={styles.about}>
            <div className={styles.container}>
                <h2>
                    Your compliance
                    <br /> powerhouse!
                </h2>

                <div className={styles.content}>
                    <div className={classNames(styles.block, styles['top-left'])}>
                        <p>
                            Founded in 2023 in Orlando, FL, <strong>Gravity Security</strong> is
                            U.S.-owned and operated, built by practitioners with{' '}
                            <strong>30+ years combined cybersecurity and compliance
                            experience</strong> — not a call-center consultancy, but a team that
                            has done the work firsthand.
                        </p>
                    </div>

                    <div className={classNames(styles.block, styles['top-right'])}>
                        <p>
                            Our practitioners hold <strong>CISSP, CISA, CISM, CCP, and CCA</strong>{' '}
                            credentials and bring hands-on experience navigating{' '}
                            <strong>FedRAMP authorizations and CMMC readiness</strong> — expertise
                            grounded in real practice, not theory.
                        </p>
                    </div>

                    <div className={classNames(styles.block, styles['bottom-left'])}>
                        <p>
                            From <strong>CMMC and FedRAMP to vCISO and AI governance</strong>, we
                            turn complex regulatory requirements into practical, audit-ready
                            programs — with a focus on real outcomes, not paperwork for its own
                            sake.
                        </p>
                    </div>

                    <div className={classNames(styles.block, styles['bottom-right'])}>
                        <p>
                            At Gravity Security, we are dedicated to building lasting partnerships
                            by delivering <strong>efficient, credentialed, and impactful compliance
                            solutions</strong>. We aim to be a trusted partner in your long-term
                            success, helping you navigate the challenges of today's regulatory
                            landscape with confidence.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutSection;